import * as Yup from 'yup';

const toOptionalNumber = (schema: Yup.NumberSchema<number | undefined>) =>
  schema.transform((val, orig) =>
    orig === '' || orig === null ? undefined : val
  );

const requiredText = () => Yup.string().trim().required('Required');

export const coversCancellationValidationSchema = (
  lineExternalCode?: string,
  rowIsEnabled?: (row: any) => boolean,
  amendmentType?: string
) => {
  const isCancellation = amendmentType === 'PolicyCancellation';
  const rowSchema = Yup.object({
    // Premium Variance field for cancellation scenarios with range validation
    coverPremiumVariance: Yup.number()
      .transform((val, orig) => {
        // Handle partial typing of negative numbers
        if (orig === '' || orig === null || orig === undefined)
          return undefined;
        if (orig === '-' || orig === '+') return undefined; // Allow typing - or + without validation error

        return val;
      })
      .when('coverPremiumAmount', ([coverPremiumAmount], schema) => {
        let result = schema
          .min(-(coverPremiumAmount ?? 0), 'Invalid Value')
          .max(0, 'Invalid Value');

        if (isCancellation) {
          result = result.required('Required');
        }

        return result;
      })
  }).test('enabled-skip', 'ok', function (row) {
    if (rowIsEnabled && !rowIsEnabled(row)) return true;

    return true;
  });

  return Yup.object({
    covers: Yup.array().of(rowSchema)
  });
};
